import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=480d299c&scoped=true&"
import script from "./knowledge.js?vue&type=script&lang=js&"
export * from "./knowledge.js?vue&type=script&lang=js&"
import style0 from "./knowledge.css?vue&type=style&index=0&id=480d299c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d299c",
  null
  
)

export default component.exports